// Gala icon set ("gala-copy"), https://github.com/sisyphusion/gala-icons -- GPL licensed.
// A solid card over a dashed outline: the same sheet somewhere else, which is
// what "copy to board" does. Strokes currentColor like its CirclePlusIcon
// sibling, so the button's text colour reaches it.
export const CopyToBoardIcon = (props) => (
  <svg
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={16}
    viewBox="0 0 256 256"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect height={144} rx={32} ry={32} width={144} x={16} y={16} />
    {/* The four dashed corners of the sheet behind it. The mirrored three keep
        the source's scale(-1) transforms rather than being re-derived by hand --
        the arcs are identical, only their quadrant differs. */}
    <path d="M 95.999712,127.9996 A 31.999891,31.999891 0 0 1 127.9996,95.999712" />
    <path d="m -239.99922,127.9996 a 31.999891,31.999891 0 0 1 31.99989,-31.999888" transform="scale(-1,1)" />
    <path d="m -239.99922,-207.99933 a 31.999891,31.999891 0 0 1 31.99989,-31.99989" transform="scale(-1)" />
    <path d="M 95.999712,-207.99933 A 31.999891,31.999891 0 0 1 127.9996,-239.99922" transform="scale(1,-1)" />
    <path d="m 159.99949,239.99923 h 15.99995" />
    <path d="m 159.99949,95.9997 h 15.99995" />
    <path d="m 95.999709,159.99949 v 15.99995" />
    <path d="m 239.99923,159.99949 v 15.99995" />
  </svg>
);
